<div ng-controller="RoleController as roleCtrl" class="modal-view">
    <c-auto-form config="roleCtrl.autoFormConfig"></c-auto-form>
</div>
